var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("form", [
      _c("h2", [_vm._v("Account Details")]),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-grey" }, [
        _c("div", { staticClass: "panel-body" }, [
          _c(
            "div",
            { staticClass: "form-horizontal" },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-lg-6" },
                  [
                    _c("field-input", {
                      attrs: {
                        model: _vm.$v.stateFirstName,
                        "field-name": "First name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-lg-6" },
                  [
                    _c("field-input", {
                      attrs: {
                        model: _vm.$v.stateLastName,
                        "field-name": "Last name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-lg-6" },
                  [
                    _c("field-input", {
                      attrs: {
                        model: _vm.$v.stateEmail,
                        "field-name": "Email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user && _vm.user.region
                  ? _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { "has-error": _vm.$v.phoneModel.$error },
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "control-label col-sm-4" },
                            [_vm._v("Mobile phone:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-sm-8" },
                            [
                              _c("vue-tel-input", {
                                ref: "phone",
                                attrs: {
                                  name: "phone",
                                  "preferred-countries": ["AU", "GB", "US"],
                                  "default-country": _vm.$user.region
                                    ? _vm.$user.region.shortname
                                    : null,
                                  "auto-default-country":
                                    _vm.$user.region &&
                                    _vm.$user.region.shortname
                                      ? true
                                      : false,
                                  "style-classes": _vm.wrapperClasses,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "arrow-icon",
                                      fn: function ({ open }) {
                                        return [
                                          _vm._v(_vm._s(open ? "▲" : "▼")),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2071452782
                                ),
                                model: {
                                  value: _vm.$v.phoneModel.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.phoneModel, "$model", $$v)
                                  },
                                  expression: "$v.phoneModel.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.phoneModel,
                                  label: "Phone number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-lg-6" },
                    [
                      _vm.$vlastMode && _vm.$isCricketAus && _vm.userIsTalent
                        ? _c("client-selection", {
                            attrs: {
                              model: _vm.$v.stateCompany,
                              default: _vm.user.company,
                            },
                          })
                        : _c("field-input", {
                            attrs: {
                              model: _vm.$v.stateCompany,
                              "field-name": _vm._f("sentenceCase")(
                                _vm.$t("organisation")
                              ),
                              "show-required":
                                !_vm.userIsTalent &&
                                _vm.showClientDepartmentFields,
                              showDescription:
                                !_vm.$vlastMode &&
                                (_vm.userIsClient || _vm.userIsTalent),
                              descriptionText:
                                "Your business name. Leave blank if not applicable",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.userIsAdmin || _vm.userIsClient || _vm.userIsManager
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-lg-6" },
                        [
                          _c("field-input", {
                            attrs: {
                              model: _vm.$v.statePosition,
                              "field-name": "Job Title",
                              "show-required": _vm.showClientDepartmentFields,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c("div", { staticClass: "row" }, [
                    (_vm.userIsAdmin || _vm.userIsClient) &&
                    _vm.$showDepartmentField
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-lg-6" },
                          [
                            _vm.user.role === "restricted-admin"
                              ? _c("department-multiple-selection", {
                                  attrs: {
                                    model: _vm.$v.stateDepartments,
                                    default: _vm.user.departments,
                                  },
                                })
                              : _c("department-selection", {
                                  attrs: {
                                    model: _vm.$v.stateDepartment,
                                    default: _vm.user.department,
                                  },
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$userIsSuperAdmin && _vm.userIsAdmin && _vm.$vlastMode
                      ? _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: { "has-error": _vm.$v.stateRole.$error },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("* Role: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-8" },
                                [
                                  _c("selectize", {
                                    staticClass:
                                      "single selectize selectize-single selectize-bordered selectized",
                                    class: _vm.$v.stateRole.$error
                                      ? "has-error red-border"
                                      : "",
                                    attrs: {
                                      multiple: false,
                                      name: "role",
                                      options: _vm.roleOptions,
                                    },
                                    model: {
                                      value: _vm.$v.stateRole.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.stateRole,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.stateRole.$model",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.$v.stateRole.$error
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "help-block pull-right",
                                        },
                                        [_vm._v("Role is required")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsClient && _vm.$paymentsModuleEnabled
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-lg-6" },
                      [
                        _c("field-input", {
                          attrs: {
                            model: _vm.$v.stateInvoiceTo,
                            "field-name": "Invoice To",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsTalent
                ? [
                    _c("div", { staticClass: "row" }, [
                      _vm.$genderModuleEnabled
                        ? _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  "form-group",
                                  _vm.errorClass("profile.gender"),
                                ],
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "control-label col-sm-4" },
                                  [_vm._v("Gender:")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-8" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "radio radio-inline radio-primary checkbox-filter-gender",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.$v.stateGender.$model,
                                              expression:
                                                "$v.stateGender.$model",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "profile.gender",
                                            id: "gender_male",
                                            value: "male",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.$v.stateGender.$model,
                                              "male"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.$v.stateGender,
                                                "$model",
                                                "male"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm._m(0),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "radio radio-inline radio-primary checkbox-filter-gender",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.$v.stateGender.$model,
                                              expression:
                                                "$v.stateGender.$model",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "profile.gender",
                                            id: "gender_female",
                                            value: "female",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.$v.stateGender.$model,
                                              "female"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.$v.stateGender,
                                                "$model",
                                                "female"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.$isWSL
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "radio radio-inline radio-primary checkbox-filter-gender",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.$v.stateGender.$model,
                                                  expression:
                                                    "$v.stateGender.$model",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "profile.gender",
                                                id: "gender_other",
                                                value: "other",
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.$v.stateGender.$model,
                                                  "other"
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.$v.stateGender,
                                                    "$model",
                                                    "other"
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticStyle: {
                                                  "font-size": "16px",
                                                  "line-height": "26px",
                                                },
                                                attrs: { for: "gender_other" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Other\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("help-block", {
                                      attrs: { field: "profile.gender" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-lg-6" },
                        [
                          _c("field-input", {
                            attrs: {
                              model: _vm.$v.stateWebsite,
                              "field-name": "Star's Website",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.$userIsManager && _vm.$managerModuleEnabled
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("Manager:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-8" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.stateManager,
                                      expression: "stateManager",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: _vm.stateManager },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.stateManager = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("Manager Agency:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-8" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.stateAgency,
                                      expression: "stateAgency",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", disabled: "" },
                                  domProps: { value: _vm.stateAgency },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.stateAgency = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$talentDateOfBirthEnabled
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  "has-error": _vm.$v.stateDateOfBirth.$error,
                                },
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "control-label col-sm-4" },
                                  [_vm._v("* Date of Birth:")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-8" },
                                  [
                                    _c("flat-pickr", {
                                      staticClass: "form-control pickdate",
                                      attrs: {
                                        config: _vm.datePickerConfig,
                                        placeholder: "Please select a date",
                                        name: "date_of_birth",
                                      },
                                      model: {
                                        value: _vm.$v.stateDateOfBirth.$model,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.$v.stateDateOfBirth,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.stateDateOfBirth.$model",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.$v.stateDateOfBirth.$error
                                      ? _c(
                                          "div",
                                          { staticClass: "help-block" },
                                          [
                                            !_vm.$v.stateDateOfBirth.required
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Date of birth is required"
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$userIsAdmin && !_vm.$vlastMode
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("E-Sports:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-8",
                                  staticStyle: { "padding-top": "15px" },
                                },
                                [
                                  _c("toggle-button", {
                                    attrs: {
                                      sync: true,
                                      color: {
                                        checked: _vm.$brandPrimary,
                                        unchecked: "#b7b7b7",
                                      },
                                      labels: {
                                        checked: "YES",
                                        unchecked: "NO",
                                      },
                                    },
                                    model: {
                                      value: _vm.$v.stateCanSetEsports.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.stateCanSetEsports,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.stateCanSetEsports.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$retired
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-6 flex items-center" },
                            [
                              _c("div", { staticClass: "control-label" }, [
                                _vm._v(_vm._s(_vm.$t("Retired Status")) + ":"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-between spacer-l-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-full",
                                      class: {
                                        "has-error": _vm.$v.stateRetired.$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "radio radio-primary" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.$v.stateRetired.$model,
                                                expression:
                                                  "$v.stateRetired.$model",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "retired",
                                              id: "retired_active",
                                              value: "active",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.$v.stateRetired.$model,
                                                "active"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.$v.stateRetired,
                                                  "$model",
                                                  "active"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: { for: "retired_active" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Active\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "radio radio-primary" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.$v.stateRetired.$model,
                                                expression:
                                                  "$v.stateRetired.$model",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "retired",
                                              id: "retired_retired",
                                              value: "retired",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.$v.stateRetired.$model,
                                                "retired"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.$v.stateRetired,
                                                  "$model",
                                                  "retired"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: { for: "retired_retired" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.$t("Retired")) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.$isNflClient
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "radio radio-primary",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.$v.stateRetired
                                                        .$model,
                                                    expression:
                                                      "$v.stateRetired.$model",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "retired",
                                                  id: "retired_coach",
                                                  value: "coach",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.$v.stateRetired.$model,
                                                    "coach"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$set(
                                                      _vm.$v.stateRetired,
                                                      "$model",
                                                      "coach"
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "retired_coach",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(_vm.$t("Coach")) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-footer" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-sm btn-primary",
                attrs: {
                  type: "submit",
                  click: _vm.handleUpdateDetails,
                  disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
                },
              },
              [_vm._v("Save Changes")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "gender_male" } }, [
      _c("i", { staticClass: "fa fa-male" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "gender_female" } }, [
      _c("i", { staticClass: "fa fa-female" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }